import React, { PropTypes } from 'react';
import { tr } from '../utils';

const L10n = ({ item, lang, raw }) => {
  const text = tr(item, lang);
  return (raw ? <span dangerouslySetInnerHTML={{ __html: text }} /> : <span>{text}</span>);
};

L10n.propTypes = {
  lang: PropTypes.string.isRequired,
  item: PropTypes.any.isRequired,
  raw: PropTypes.bool,
};

export default L10n;



// WEBPACK FOOTER //
// ./common/components/L10n.js